// OIDC redirect target. Real implementation exchanges the auth code +
// PKCE verifier for tokens, then redirects to /dashboard. First vertical
// slice wires this up.
export default function AuthCallback() {
  return (
    <div className="flex h-full items-center justify-center text-text-secondary">
      Completing sign-in…
    </div>
  );
}
